import { LOADING, LOGOUT, SET_MESSAGE } from "../../Actions/Types";
import { UserLogoutActionApi } from "../../Api/UserAction/LogoutActionApi";
import getBaseURL from "../../Helpers/getBaseURL";

// service to perform logout
const UserLogoutActionService = (
    accessToken: string, // access token 
    dispatch: Function, // dispatch function for redux store
    navigate: Function, // navigate function for router
    t: Function, // i18next t function 
    handleLogOutConfirmModalClose: Function, // function to close logout confirmation modal
    logout?: Function
) => {

    console.log("UserLogoutActionService is called", logout);

    // Loading true
    dispatch({
        type: LOADING,
        payload: true,
    });

    // api to perform user logout
    UserLogoutActionApi(accessToken).then((response) => {

        // check if api response is ok
        if (response.status === 200) {

            // Close Modal
            handleLogOutConfirmModalClose()

            // Logout
            dispatch({
                type: LOGOUT,
            });

            // Logout Msg
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t("Logout Success Msg", { returnObjects: true }),
                    "toast_type": "success",
                    "onclose": null
                }
            });

            // Redirect
            /* navigate("/front/login");
            // Loading false
            dispatch({
                type: LOADING,
                payload: false,
            }); */

            
            if (logout) {
                console.log("logout function available");
                dispatch({
                    type: LOADING,
                    payload: false,
                });
                const baseURL = getBaseURL();
                setTimeout(() => {
                    logout({ logoutParams: { returnTo: `${baseURL}/front/login?logout` } })    
                }, 300);
                
               
            }
            else {
                navigate("/front/login?logout");
                // Loading false
                dispatch({
                    type: LOADING,
                    payload: false,
                });
            }

        }

    }
    );
};

export default UserLogoutActionService;